import { CATALOG_HOME_LINK_TYPE } from "@stadium/shared/src/constants/stores/routes";

// Banner (B Series) Variants
export const B_01 = "B01";
export const B_02 = "B02";
export const B_02b = "B02b";
export const B_03 = "B03";
export const B_04 = "B04";
export const B_05 = "B05";
export const B_06 = "B06";
export const B_07 = "B07";
export const B_08 = "B08";
export const B_09 = "B09";
export const B_10 = "B10";
export const B_12 = "B12";
export const B_13 = "B13";
export const B_14 = "B14";
export const B_15 = "B15";
export const B_16 = "B16";
export const B_17 = "B17";
export const B_18 = "B18";
export const B_19 = "B19";
export const B_20 = "B20";
export const B_21 = "B21";
export const B_22 = "B22";
export const B_23 = "B23";

// Hero (H Series) Variants
export const H_01 = "H01";
export const H_02 = "H02";
export const H_03 = "H03";
export const H_04 = "H04";
export const H_05 = "H05";
export const H_06 = "H06";
export const H_07 = "H07";
export const H_08 = "H08";

// Logo Strips (L Series) Variants
export const L_03 = "LS03";

// Blog Entry (BE Series) Variants
export const BE_01 = "BE01";
export const BE_03 = "BE03";
export const BE_04 = "BE04";
export const BE_05 = "BE05";
export const BE_06 = "BE06";

// Bento Grid (BG Series) Variants
export const BG_01 = "BG01";
export const BG_02 = "BG02";
export const BG_03 = "BG03";

// Catalog Entries (CE Series) Variants
export const CE_10 = "CE10";
export const CE_11 = "CE11";
export const CE_13 = "CE13";

// Testimonial (T Series) Variants
export const T_01 = "T01";
export const T_001 = "T001";
export const T_02 = "T002";

// Other Variants
export const O_03 = "O03";
export const A_01 = "A01";

export type BannerVariant =
  | typeof B_01
  | typeof B_02
  | typeof B_02b
  | typeof B_03
  | typeof B_04
  | typeof B_05
  | typeof B_06
  | typeof B_07
  | typeof B_08
  | typeof B_09
  | typeof B_10
  | typeof B_12
  | typeof B_13
  | typeof B_14
  | typeof B_15
  | typeof B_16
  | typeof B_17
  | typeof B_18
  | typeof B_19
  | typeof B_20
  | typeof B_21
  | typeof B_22
  | typeof B_23;

export type HeroVariant =
  | typeof H_01
  | typeof H_02
  | typeof H_03
  | typeof H_04
  | typeof H_05
  | typeof H_06
  | typeof H_07
  | typeof H_08;

export type LogoStripsVariant = typeof L_03;

export type BlogEntryVariant =
  | typeof BE_01
  | typeof BE_03
  | typeof BE_04
  | typeof BE_05
  | typeof BE_06;

export type BentoGridVariant = typeof BG_01 | typeof BG_02 | typeof BG_03;

export type CatalogEntriesVariant = typeof CE_10 | typeof CE_11 | typeof CE_13;

export type TestimonialVariant = typeof T_01 | typeof T_001 | typeof T_02;

export const BANNER_VARIANTS = [
  { label: B_01, value: B_01 },
  { label: B_02, value: B_02 },
  { label: B_02b, value: B_02b },
  { label: B_03, value: B_03 },
  { label: B_04, value: B_04 },
  { label: B_05, value: B_05 },
  { label: B_06, value: B_06 },
  { label: B_07, value: B_07 },
  { label: B_08, value: B_08 },
  { label: B_09, value: B_09 },
  { label: B_10, value: B_10 },
  { label: B_12, value: B_12 },
  { label: B_13, value: B_13 },
  { label: B_14, value: B_14 },
  { label: B_15, value: B_15 },
  { label: B_16, value: B_16 },
  { label: B_17, value: B_17 },
  { label: B_18, value: B_18 },
  { label: B_19, value: B_19 },
  { label: B_20, value: B_20 },
  { label: B_21, value: B_21 },
  { label: B_22, value: B_22 },
  { label: B_23, value: B_23 },
];

export const HERO_VARIANTS = [
  { label: H_01, value: H_01 },
  { label: H_02, value: H_02 },
  { label: H_03, value: H_03 },
  { label: H_04, value: H_04 },
  { label: H_05, value: H_05 },
  { label: H_06, value: H_06 },
  { label: H_07, value: H_07 },
  { label: H_08, value: H_08 },
];

export const LOGO_STRIPS_VARIANTS = [{ label: L_03, value: L_03 }];

export const BLOG_ENTRY_VARIANTS = [
  { label: BE_01, value: BE_01 },
  { label: BE_03, value: BE_03 },
  { label: BE_04, value: BE_04 },
  { label: BE_05, value: BE_05 },
  { label: BE_06, value: BE_06 },
];

export const BENTO_GRID_VARIANTS = [
  { label: BG_01, value: BG_01 },
  { label: BG_02, value: BG_02 },
  { label: BG_03, value: BG_03 },
];

export const CATALOG_ENTRIES_VARIANTS = [
  { label: CE_10, value: CE_10 },
  { label: CE_11, value: CE_11 },
  { label: CE_13, value: CE_13 },
];

export const TESTIMONIAL_VARIANTS = [
  { label: T_01, value: T_01 },
  { label: T_001, value: T_001 },
  { label: T_02, value: T_02 },
];

// Default Values
export interface B01ListItem {
  text: string;
  icon: string;
  iconAlt: string;
}

export interface B05BulletPoint {
  text: string;
  image: string;
  imageAlt: string;
}

export const BANNER_DEFAULTS = {
  [B_01]: {
    heading: "Swag that lives up to your brand",
    primaryButtonText: "VIEW CATALOG",
    primaryButtonUrl: "#",
    mobileImg: "https://cdn.bystadium.com/plasmic/static-slices/b09-mobile-img.png",
    desktopImg: "https://cdn.bystadium.com/plasmic/static-slices/b09-desktop-img.png",
    imageAlt: "Newsletter signup",
    backgroundColor: "#f5f5f5",
    listItems: [
      {
        text: "Pre-curated kits for Employee onboarding",
        icon: "https://cdn.bystadium.com/plasmic/static-slices/icon-shop.svg",
        iconAlt: "Shopping icon",
      },
      {
        text: "Pre-curated kits for Employee onboarding",
        icon: "https://cdn.bystadium.com/plasmic/static-slices/icon-shop.svg",
        iconAlt: "Shopping icon",
      },
      {
        text: "Pre-curated kits for Employee onboarding",
        icon: "https://cdn.bystadium.com/plasmic/static-slices/icon-shop.svg",
        iconAlt: "Shopping icon",
      },
      {
        text: "Pre-curated kits for Employee onboarding",
        icon: "https://cdn.bystadium.com/plasmic/static-slices/icon-shop.svg",
        iconAlt: "Shopping icon",
      },
    ] as B01ListItem[],
  },
  [B_02]: {
    slides: [
      {
        image: "https://cdn.bystadium.com/plasmic/static-slices/b09-desktop-img.png",
        imageAlt: "Event kits slide 1",
        heading: "Kits for every event - Slide 1",
        description:
          "It's all in the details! Bring your brand to life stitch by stitch with embroidery that's perfect for uniforms or premium swag.",
      },
      {
        image: "https://cdn.bystadium.com/plasmic/static-slices/b10-desktop-img.png",
        imageAlt: "Event kits slide 2",
        heading: "Kits for every event - Slide 2",
        description:
          "It's all in the details! Bring your brand to life stitch by stitch with embroidery that's perfect for uniforms or premium swag.",
      },
      {
        image: "https://cdn.bystadium.com/plasmic/static-slices/b09-desktop-img.png",
        imageAlt: "Event kits slide 3",
        heading: "Kits for every event - Slide 3",
        description:
          "It's all in the details! Bring your brand to life stitch by stitch with embroidery that's perfect for uniforms or premium swag.",
      },
      {
        image: "https://cdn.bystadium.com/plasmic/static-slices/b10-desktop-img.png",
        imageAlt: "Event kits slide 4",
        heading: "Kits for every event - Slide 4",
        description:
          "It's all in the details! Bring your brand to life stitch by stitch with embroidery that's perfect for uniforms or premium swag.",
      },
      {
        image: "https://cdn.bystadium.com/plasmic/static-slices/b10-desktop-img.png",
        imageAlt: "Event kits slide 5",
        heading: "Kits for every event - Slide 5",
        description:
          "It's all in the details! Bring your brand to life stitch by stitch with embroidery that's perfect for uniforms or premium swag.",
      },
    ],
    backgroundColor: "#f5f5f5",
  },
  [B_02b]: {
    slides: [
      {
        image: "https://cdn.bystadium.com/plasmic/static-slices/b09-mobile-img.png",
        imageAlt: "Kits for every event - Slide 1",
        heading: "Kits for every event - Slide 1",
        description:
          "It's all in the details! Bring your brand to life stitch by stitch with embroidery that's perfect for uniforms or premium swag.",
        buttonText: "View Catalog",
        buttonUrl: "#",
      },
      {
        image: "https://cdn.bystadium.com/plasmic/static-slices/b09-mobile-img.png",
        imageAlt: "Kits for every event - Slide 2",
        heading: "Kits for every event - Slide 2",
        description:
          "It's all in the details! Bring your brand to life stitch by stitch with embroidery that's perfect for uniforms or premium swag.",
        buttonText: "Browse Kits",
        buttonUrl: "#",
      },
      {
        image: "https://cdn.bystadium.com/plasmic/static-slices/b09-mobile-img.png",
        imageAlt: "Kits for every event - Slide 3",
        heading: "Kits for every event - Slide 3",
        description:
          "It's all in the details! Bring your brand to life stitch by stitch with embroidery that's perfect for uniforms or premium swag.",
        buttonText: "Shop Now",
        buttonUrl: "#",
      },
      {
        image: "https://cdn.bystadium.com/plasmic/static-slices/b09-mobile-img.png",
        imageAlt: "Kits for every event - Slide 4",
        heading: "Kits for every event - Slide 4",
        description:
          "It's all in the details! Bring your brand to life stitch by stitch with embroidery that's perfect for uniforms or premium swag.",
        buttonText: "Get Started",
        buttonUrl: "#",
      },
      {
        image: "https://cdn.bystadium.com/plasmic/static-slices/b09-mobile-img.png",
        imageAlt: "Kits for every event - Slide 5",
        heading: "Kits for every event - Slide 5",
        description:
          "It's all in the details! Bring your brand to life stitch by stitch with embroidery that's perfect for uniforms or premium swag.",
        buttonText: "Learn More",
        buttonUrl: "#",
      },
    ],
    backgroundColor: "#f5f5f5",
  },
  [B_03]: {
    eyebrowText: "SWAG AUTOMATION",
    heading: "Gifting on Autopilot",
    features: [
      {
        icon: "https://cdn.bystadium.com/plasmic/static-slices/icon-shop.svg",
        iconAlt: "Create a Swag Shop",
        text: "Create a Swag Shop",
        video: "https://cdn.bystadium.com/plasmic/static-slices/video1.mp4",
      },
      {
        icon: "https://cdn.bystadium.com/plasmic/static-slices/icon-storage.svg",
        iconAlt: "Swag Storage & Kit Fulfillment",
        text: "Swag Storage & Kit Fulfillment",
        video: "https://cdn.bystadium.com/plasmic/static-slices/video2.mp4",
      },
      {
        icon: "https://cdn.bystadium.com/plasmic/static-slices/icon-gift.svg",
        iconAlt: "Automate Your Gifting",
        text: "Automate Your Gifting",
        video: "https://cdn.bystadium.com/plasmic/static-slices/video3.mp4",
      },
      {
        icon: "https://cdn.bystadium.com/plasmic/static-slices/icon-inventory.svg",
        iconAlt: "Real-Time Inventory Management",
        text: "Real-Time Inventory Management",
        video: "https://cdn.bystadium.com/plasmic/static-slices/video4.mp4",
      },
    ],
    ctaText: "BOOK A DEMO",
    ctaLinkType: CATALOG_HOME_LINK_TYPE,
  },
  [B_04]: {
    eyebrow: "NOT JUST MERCH",
    heading: "It's a Statement",
    description:
      "Discover a fresh way to give and wear swag. Curated drops. Custom designs. Done right.",
    buttonText: "GET STARTED",
    buttonLinkType: CATALOG_HOME_LINK_TYPE,
    mobileImg: "https://cdn.bystadium.com/plasmic/static-slices/b04-mob-img.png",
    desktopImg: "https://cdn.bystadium.com/plasmic/static-slices/b04-desktop-img.png",
    imageAlt: "Statement swag",
    overlayOpacity: 0.7,
  },
  [B_05]: {
    heading: "Make them feel Special",
    description: "Get peak employee satisfaction with corporate gifting.",
    bulletPoints: [
      { text: "Kits starting from $45", image: "", imageAlt: "" },
      { text: "Kits starting from $45", image: "", imageAlt: "" },
      { text: "Kits starting from $45", image: "", imageAlt: "" },
    ] as B05BulletPoint[],
    primaryButtonText: "GET STARTED",
    primaryButtonLinkType: CATALOG_HOME_LINK_TYPE,
    secondaryButtonText: "VIEW CATALOG",
    secondaryButtonLinkType: CATALOG_HOME_LINK_TYPE,
    mobileImg: "https://cdn.bystadium.com/plasmic/static-slices/b04-mob-img.png",
    desktopImg: "https://cdn.bystadium.com/plasmic/static-slices/b04-desktop-img.png",
    imageAlt: "Corporate gifting",
    overlayOpacity: 0.6,
  },
  [B_06]: {
    eyebrow: "YOUR ROBUST SWAG SOLUTION",
    heading: "Swag that lives up to your brand",
    description:
      "Let your swag speak volumes with premium products from the world's greatest catalog.",
    primaryButtonText: "GET STARTED",
    primaryButtonLinkType: CATALOG_HOME_LINK_TYPE,
    secondaryButtonText: "VIEW CATALOG",
    secondaryButtonLinkType: CATALOG_HOME_LINK_TYPE,
    mobileImg: "https://cdn.bystadium.com/plasmic/static-slices/b04-mob-img.png",
    desktopImg: "https://cdn.bystadium.com/plasmic/static-slices/b04-desktop-img.png",
    imageAlt: "Brand swag solution",
    overlayOpacity: 0.6,
  },
  [B_07]: {
    eyebrow: "STAY UPDATED ON",
    heading: "The best in Swag",
    subtext: "Subscribe to our Newsletter",
    inputPlaceholder: "ENTER EMAIL",
    mobileImg: "https://cdn.bystadium.com/plasmic/static-slices/b04-mob-img.png",
    desktopImg: "https://cdn.bystadium.com/plasmic/static-slices/b04-desktop-img.png",
    imageAlt: "Newsletter signup",
    overlayOpacity: 0.8,
  },
  [B_08]: {
    heading: "Swag that lives up to your brand",
    description:
      "Let your swag speak volumes with premium products from the world's greatest catalog.",
    primaryButtonText: "GET STARTED",
    primaryButtonLinkType: CATALOG_HOME_LINK_TYPE,
    secondaryButtonText: "VIEW CATALOG",
    secondaryButtonLinkType: CATALOG_HOME_LINK_TYPE,
    mobileImg: "https://cdn.bystadium.com/plasmic/static-slices/b09-mobile-img.png",
    desktopImg: "https://cdn.bystadium.com/plasmic/static-slices/b09-desktop-img.png",
    imageAlt: "Newsletter signup",
    backgroundColor: "#f5f5f5",
  },
  [B_09]: {
    heading: "Swag that lives up to your brand",
    description:
      "Let your swag speak volumes with premium products from the world's greatest catalog.",
    primaryButtonText: "GET STARTED",
    primaryButtonLinkType: CATALOG_HOME_LINK_TYPE,
    secondaryButtonText: "VIEW CATALOG",
    secondaryButtonLinkType: CATALOG_HOME_LINK_TYPE,
    mobileImg: "https://cdn.bystadium.com/plasmic/static-slices/b09-mobile-img.png",
    desktopImg: "https://cdn.bystadium.com/plasmic/static-slices/b09-desktop-img.png",
    imageAlt: "Brand swag",
    backgroundColor: "#f5f5f5",
  },
  [B_10]: {
    heading: "Kits for every event",
    description:
      "It's all in the details! Bring your brand to life stitch by stitch with embroidery that's perfect for uniforms or premium swag.",
    buttonText: "BROWSE CATALOG",
    buttonLinkType: CATALOG_HOME_LINK_TYPE,
    mobileImg: "https://cdn.bystadium.com/plasmic/static-slices/b10-mobile-img.png",
    desktopImg: "https://cdn.bystadium.com/plasmic/static-slices/b10-desktop-img.png",
    imageAlt: "Event kits",
    backgroundColor: "#f5f5f5",
  },
  [B_12]: {
    heading: "Swag that lives up to your brand",
    description:
      "Let your swag speak volumes with premium products from the world's greatest catalog.",
    primaryButtonText: "GET STARTED",
    primaryButtonUrl: "#",
    mobileImg: "https://cdn.bystadium.com/plasmic/static-slices/b09-mobile-img.png",
    desktopImg: "https://cdn.bystadium.com/plasmic/static-slices/b09-desktop-img.png",
    imageAlt: "Brand swag",
    backgroundColor: "#f5f5f5",
  },
  [B_13]: {
    heading: "Swag that lives up to your brand",
    description:
      "Let your swag speak volumes with premium products from the world's greatest catalog.",
    primaryButtonText: "GET STARTED",
    primaryButtonUrl: "#",
    mobileImg: "https://cdn.bystadium.com/plasmic/static-slices/b09-mobile-img.png",
    desktopImg: "https://cdn.bystadium.com/plasmic/static-slices/b09-desktop-img.png",
    imageAlt: "Brand swag",
    backgroundColor: "#f5f5f5",
  },
  [B_14]: {
    heading: "Swag that lives up to your brand",
    description:
      "Let your swag speak volumes with premium products from the world's greatest catalog.",
    primaryButtonText: "GET STARTED",
    primaryButtonUrl: "#",
    image: "https://cdn.bystadium.com/plasmic/static-slices/b09-mobile-img.png",
    imageAlt: "Brand swag",
    backgroundColor: "#f5f5f5",
  },
  [B_15]: {
    image: "https://cdn.bystadium.com/plasmic/static-slices/b09-mobile-img.png",
    imageAlt: "Brand swag",
    subtext: "Subscribe to our Newsletter",
    inputPlaceholder: "ENTER EMAIL",
    logoImageAlt: "",
    poweredByImageAlt: "",
    backgroundColor: "#f5f5f5",
  },
  [B_16]: {
    eyebrow: "REDEFINING",
    heading: "Swag Management",
    description:
      "Let your swag speak volumes with premium products from the world's greatest catalog.",
    primaryButtonText: "GET STARTED",
    primaryButtonUrl: "#",
    image: "https://cdn.bystadium.com/plasmic/static-slices/b09-mobile-img.png",
    imageAlt: "Brand swag",
    backgroundColor: "#f5f5f5",
  },
  [B_17]: {
    heading: "Pre Curated",
    description:
      "Let your swag speak volumes with premium products from the world's greatest catalog.",
    primaryButtonText: "GET STARTED",
    primaryButtonUrl: "#",
    image: "https://cdn.bystadium.com/plasmic/static-slices/b09-mobile-img.png",
    imageAlt: "Brand swag",
    backgroundColor: "#f5f5f5",
  },
  [B_18]: {
    heading: "Pre Curated",
    description:
      "Let your swag speak volumes with premium products from the world's greatest catalog.",
    primaryButtonText: "GET STARTED",
    primaryButtonUrl: "#",
    image: "https://cdn.bystadium.com/plasmic/static-slices/b09-mobile-img.png",
    imageAlt: "Brand swag",
    backgroundColor: "#f5f5f5",
  },
  [B_19]: {
    heading: "Pre Curated Kits",
    description:
      "Discover a fresh way to give and wear swag. Curated drops. Custom designs. Done right.",
    primaryButtonText: "Browse catalog",
    primaryButtonUrl: "#",
    backgroundColor: "#f5f5f5",
  },
  [B_20]: {
    newsletterTitle: "Subscribe to our Newsletter",
    newsletterPlaceholder: "YOUR EMAIL ADDRESS",
    newsletterButtonAriaLabel: "Subscribe",
    logoImageAlt: "",
    primaryButtonText: "View Catalog",
    primaryButtonUrl: "#",
    poweredByImageAlt: "",
    backgroundColor: "#f5f5f5",
  },
  [B_21]: {
    heading: "Pre Curated Kits",
    description:
      "Discover a fresh way to give and wear swag. Curated drops. Custom designs. Done right.",
    primaryButtonText: "Browse catalog",
    primaryButtonUrl: "#",
    watermark: "https://cdn.bystadium.com/plasmic/static-slices/swagmagic-desktop.png",
    backgroundColor: "#f5f5f5",
  },
  [B_22]: {
    heading: "Swag that lives up to your brand",
    description:
      "Let your swag speak volumes with premium products from the world's greatest catalog.",
    primaryButtonText: "GET STARTED",
    primaryButtonUrl: "#",
    image: "https://cdn.bystadium.com/plasmic/static-slices/b09-mobile-img.png",
    imageAlt: "Brand swag",
    backgroundColor: "#f5f5f5",
  },
  [B_23]: {
    heading: "Event swag took my qualified leads numbers to 10x",
    description: "Event swag did more than attract attention—it built real connections.",
  },
};

export const BLOG_ENTRY_DEFAULTS = {
  [BE_06]: {
    cards: [
      {
        image: "",
        imageAlt: "",
        title: "Employee Recognition",
        description:
          "Boring mugs are out. Here's how to create swag that people want to flex—on Zoom and IRL.",
        link: "",
      },
      {
        image: "",
        imageAlt: "",
        title: "Event and Tradeshows",
        description:
          "Discover how getting your team branded merch may actually increase brand awareness.",
        link: "",
      },
      {
        image: "",
        imageAlt: "",
        title: "Client Gifting",
        description:
          "We're breaking down how smart merch can increase employee retention and client loyalty. Spoiler: it works.",
        link: "",
      },
    ],
  },
};

export const HERO_DEFAULTS = {
  [H_01]: {
    eyebrowText: "SWAG THAT SPARKS CONNECTION",
    heading: "Welcome to the Center of Swag",
    description:
      "Let your swag speak volumes with premium products from the world's greatest catalog.",
    ctaText: "GET STARTED",
    ctaLink: "#",
    desktopImg: "https://cdn.bystadium.com/plasmic/static-slices/hero-desktop-img.png",
    mobileImg: "https://cdn.bystadium.com/plasmic/static-slices/hero-mobile-img.png",
    imageAlt: "Person holding colorful swag t-shirt",
  },
  [H_02]: {
    heading: "Apparel",
    description:
      "Custom apparel they'll actually wear. From t-shirts and hoodies to polos and jackets, create branded gear your team, clients, and community will love with no minimums, global delivery,and community will love with no minimums, global delivery,",
    primaryButtonText: "View Catalog",
    primaryButtonUrl: "#",
    secondaryButtonText: "Browse Kits",
    secondaryButtonUrl: "#",
    heroImage: "https://cdn.bystadium.com/plasmic/static-slices/b09-desktop-img.png",
    heroImageAlt: "Employee recognition",
  },
  [H_03]: {
    heading: "The Walking Billboard. Swag as Advertisement",
    description:
      "Celebrate your team with thoughtful swag—perfect for milestones, appreciation, or everyday wins.",
    teamTitle: "Team Swagmagic",
    badgeLogo: "https://cdn.bystadium.com/plasmic/static-slices/h07-g2-logo.png",
    badgeLogoAlt: "G2 Reviews",
    heroImage: "https://cdn.bystadium.com/plasmic/static-slices/b09-desktop-img.png",
    heroImageAlt: "Employee recognition",
  },
  [H_04]: {
    eyebrow: "YOUR ROBUST SWAG SOLUTION",
    heading: "Swag that lives up to your brand",
    description:
      "Let your swag speak volumes with premium products from the world's greatest catalog.",
    primaryButtonText: "GET STARTED",
    primaryButtonLinkType: CATALOG_HOME_LINK_TYPE,
    primaryButtonOtherUrl: "",
    primaryButtonCategorySlug: "",
    image: "https://cdn.bystadium.com/plasmic/static-slices/b09-desktop-img.png",
    imageAlt: "Newsletter signup",
  },
  [H_05]: {
    heading: "Employee onboarding Simplified.",
    description:
      "Celebrate your team with thoughtful swag—perfect for milestones, appreciation, or everyday wins.",
    primaryButtonText: "View Catalog",
    primaryButtonUrl: "#",
    secondaryButtonText: "Browse Kits",
    secondaryButtonUrl: "#",
    heroImage: "https://cdn.bystadium.com/plasmic/static-slices/b09-desktop-img.png",
    heroImageAlt: "Employee recognition",
    bulletPoints: [
      { iconImage: "", iconImgAlt: "", text: "Kits starting from $45" },
      { iconImage: "", iconImgAlt: "", text: "Kits starting from $45" },
      { iconImage: "", iconImgAlt: "", text: "Kits starting from $45" },
    ],
  },
  [H_06]: {
    heading: "Make Employee Recognition Easy and Impactful",
    description:
      "Celebrate your team with thoughtful swag—perfect for milestones, appreciation, or everyday wins.",
    primaryButtonText: "View Catalog",
    primaryButtonUrl: "#",
    secondaryButtonText: "Browse Kits",
    secondaryButtonUrl: "#",
    heroImage: "https://cdn.bystadium.com/plasmic/static-slices/b09-desktop-img.png",
    heroImageAlt: "Employee recognition",
  },
  [H_07]: {
    primaryButtonWidth: "auto",
    secondaryButtonWidth: "auto",
    heading: "Make Employee Recognition Easy and Impactful",
    description:
      "Celebrate your team with thoughtful swag—perfect for milestones, appreciation, or everyday wins.",
    primaryButtonText: "View Catalog",
    primaryButtonLinkType: CATALOG_HOME_LINK_TYPE,
    secondaryButtonText: "Browse Kits",
    secondaryButtonLinkType: CATALOG_HOME_LINK_TYPE,
    heroImage: "https://cdn.bystadium.com/plasmic/static-slices/b09-desktop-img.png",
    heroImageAlt: "Employee recognition",
    showReviewBadge: true,
    reviewBadgeLogo: "https://cdn.bystadium.com/plasmic/static-slices/h07-g2-logo.png",
    reviewBadgeLogoAlt: "G2 Reviews",
    reviewRating: "4.8",
    reviewCount: "1,515",
    reviewStarIcon: "https://cdn.bystadium.com/plasmic/static-slices/h07-star-icon.svg",
    showLogoStrip: true,
    logoStripEyebrow: "FOR EVERY POSSIBLE OCCASION",
    logoStripHeading: "Loved by teams everywhere",
    companyLogo1: "https://cdn.bystadium.com/plasmic/static-slices/h07-agoda.png",
    companyLogo1Alt: "Agoda",
    companyLogo2: "https://cdn.bystadium.com/plasmic/static-slices/h07-pinterest.png",
    companyLogo2Alt: "Pinterest",
    companyLogo3: "https://cdn.bystadium.com/plasmic/static-slices/h07-amazon.png",
    companyLogo3Alt: "Amazon",
    imageAlt: "Employee recognition",
  },

  [H_08]: {
    heading: "The Walking Billboard. Swag as Advertisement",
    description: "Discover how getting your team branded merch may boost brand reach.",
    summaryDescription:
      "Unlike an ad that disappears in 3 seconds, good swag lives on—in coffee shops, airports, gyms, co-working spaces, and beyond. Welcome to the Walking Billboard Philosophy of Swag—the idea that branded merch isn’t just a giveaway.",
    teamTitle: "Team Swagmagic",
    teamDate: "20th May 2025",
    testimonialHeading: "",
    badgeLogo: { image: "", alt: "" },
    image: {
      image: "https://cdn.bystadium.com/plasmic/static-slices/b09-desktop-img.png",
      alt: "",
    },
    testimonial: {
      testimonialAuthorName: "Bernardo Cruz - Azgard9",
      testimonialAuthorImage: { image: "", alt: "" },
      testimonialAuthorCompanyLogo: { image: "", alt: "" },
    },
    className: "",
  },
};

export const LOGO_STRIPS_DEFAULTS = {
  [L_03]: {
    logoStripEyebrow: "FOR EVERY POSSIBLE OCCASION",
    logoStripHeading: "Loved by teams everywhere",
    companyLogo1: "https://cdn.bystadium.com/plasmic/static-slices/h07-agoda.png",
    companyLogo1Alt: "Agoda",
    companyLogo2: "https://cdn.bystadium.com/plasmic/static-slices/h07-pinterest.png",
    companyLogo2Alt: "Pinterest",
    companyLogo3: "https://cdn.bystadium.com/plasmic/static-slices/h07-amazon.png",
    companyLogo3Alt: "Amazon",
    companyLogo4: "https://cdn.bystadium.com/plasmic/static-slices/h07-amazon.png",
    companyLogo4Alt: "Amazon",
    companyLogo5: "https://cdn.bystadium.com/plasmic/static-slices/h07-agoda.png",
    companyLogo5Alt: "Agoda",
    companyLogo6: "https://cdn.bystadium.com/plasmic/static-slices/h07-pinterest.png",
    companyLogo6Alt: "Pinterest",
    backgroundColor: "#f9f9f9",
  },
};

export const BENTO_GRID_DEFAULTS = {
  [BG_01]: {
    contentHeading: "Every Detail Counts",
    contentDescription:
      "From top brands to local fulfillment in 170+ countries, we're redefining the way you create, send, and rock swag.",
    buttonText: "BROWSE CATALOG",
    buttonLinkType: CATALOG_HOME_LINK_TYPE,
    buttonOpenInNewTab: false,
    buttonOtherUrl: "",
    buttonCategorySlug: "",
    cards: [
      {
        cardImage: "https://cdn.bystadium.com/plasmic/static-slices/b09-desktop-img.png",
        cardImageAlt: "First Day Kit",
        cardButtonImage: "https://cdn.bystadium.com/plasmic/static-slices/h07-star-icon.svg",
        cardButtonAlt: "",
        cardButtonText: "THE FIRST DAY KIT",
      },
      {
        cardImage: "https://cdn.bystadium.com/plasmic/static-slices/b09-desktop-img.png",
        cardImageAlt: "Swag Basic",
        cardButtonImage: "https://cdn.bystadium.com/plasmic/static-slices/h07-star-icon.svg",
        cardButtonAlt: "",
        cardButtonText: "SWAG BASIC",
      },
      {
        cardImage: "https://cdn.bystadium.com/plasmic/static-slices/b09-desktop-img.png",
        cardImageAlt: "Work Ready Kit",
        cardButtonImage: "https://cdn.bystadium.com/plasmic/static-slices/h07-star-icon.svg",
        cardButtonAlt: "",
        cardButtonText: "WORK READY KIT",
      },
      {
        cardImage: "https://cdn.bystadium.com/plasmic/static-slices/b09-desktop-img.png",
        cardImageAlt: "Work Ready Kit",
        cardButtonImage: "https://cdn.bystadium.com/plasmic/static-slices/h07-star-icon.svg",
        cardButtonAlt: "",
        cardButtonText: "WORK READY KIT",
      },
    ],
    backgroundColor: "#f5f5f5",
  },
  [BG_02]: {
    heading: "Experts in the swag game",
    // Country Card
    countryCardHeading: "Swag partners in 170+ countries",
    countryCardDescription: "Be unstoppable with the world's biggest global catalog!",
    countryCardBackgroundColor: "#f6f6f6",
    countryCardFlags: [
      {
        icon: "https://cdn.bystadium.com/plasmic/static-slices/h07-star-icon.svg",
        alt: "Thailand Flag",
      },
      {
        icon: "https://cdn.bystadium.com/plasmic/static-slices/h07-star-icon.svg",
        alt: "Vietnam Flag",
      },
      {
        icon: "https://cdn.bystadium.com/plasmic/static-slices/h07-star-icon.svg",
        alt: "Germany Flag",
      },
      {
        icon: "https://cdn.bystadium.com/plasmic/static-slices/h07-star-icon.svg",
        alt: "Chile Flag",
      },
    ],
    countryCardWorldImage: "",
    countryCardWorldImageAlt: "",
    // Brand Card
    brandCardLabel: "Your Brand",
    brandCardCount: "13K+",
    brandCardSubtext: "Ways to show it",
    brandCardButtonText: "VIEW CATALOG",
    brandCardButtonLinkType: CATALOG_HOME_LINK_TYPE,
    brandCardButtonOpenInNewTab: false,
    brandCardButtonOtherUrl: "",
    brandCardButtonCategorySlug: "",
    brandCardBackgroundColor: "#f8f8f8",
    brandCardShirtImage: "",
    brandCardShirtImageAlt: "",
    // Brands Platform Card
    brandsPlatformHeading: "One platform. All your favorite brands",
    brandsPlatformBackgroundImage:
      "https://cdn.bystadium.com/plasmic/static-slices/b09-desktop-img.png",
    brandsPlatformImageAlt: "Brands platform",
    // Testimonial
    testimonialQuote:
      "The global catalog is incredibly helpful. With a swag shop, we're able to facilitate everything through that versus having to fulfill locally.",
    testimonialAuthorName: "Erin Woodard - Keyfactor",
    testimonialAuthorCompany: "Asgard9",
    testimonialAuthorImage: "https://cdn.bystadium.com/plasmic/static-slices/h07-star-icon.svg",
    testimonialBackgroundColor: "#f6f6f6",
    testimonialSwagmagicMark: "",
    // Review
    reviewBackgroundImage: "https://cdn.bystadium.com/plasmic/static-slices/b09-desktop-img.png",
    reviewImageAlt: "Customer review",
    reviewHeading: "Customisations better than the rest",
    reviewButtonText: "VIEW CATALOG",
    reviewButtonUrl: "#",
    reviewButtonLinkType: CATALOG_HOME_LINK_TYPE,
    reviewButtonOpenInNewTab: false,
    reviewButtonOtherUrl: "",
    reviewButtonCategorySlug: "",
  },
  [BG_03]: {
    heading: "Why Swagmagic?",
    cards: [
      {
        cardIcon: "",
        cardIconAlt: "Global reach",
        cardTitle: "Global reach",
        cardDescription: "Ship swag to 170+ countries with local fulfillment partners worldwide.",
        cardLinkText: "LEARN MORE",
        cardLinkUrl: "#",
      },
      {
        cardIcon: "",
        cardIconAlt: "Premium brands",
        cardTitle: "Premium brands",
        cardDescription: "Access 13,000+ products from top brands you know and love.",
        cardLinkText: "BROWSE CATALOG",
        cardLinkUrl: "#",
      },
      {
        cardIcon: "",
        cardIconAlt: "Easy customization",
        cardTitle: "Easy customization",
        cardDescription: "Design and customize swag with our intuitive online platform.",
        cardLinkText: "START DESIGNING",
        cardLinkUrl: "#",
      },
      {
        cardIcon: "",
        cardIconAlt: "Swag shops",
        cardTitle: "Swag shops",
        cardDescription: "Create branded swag shops for your team, clients, or events.",
        cardLinkText: "EXPLORE SHOPS",
        cardLinkUrl: "#",
      },
    ],
  },
};

export const CATALOG_ENTRIES_DEFAULTS = {
  [CE_10]: {
    contentHeading: "What Makes the Perfect Welcome Kit?",
    contentDescription:
      "From high-quality apparel to desk essentials and tech accessories, we curate onboarding kits that blend practicality, style, and your brand identity. Choose individual pieces or pre-curated sets designed to delight every new hire.",
    cards: [
      {
        id: "1",
        title: "THE FIRST DAY KIT",
        description:
          "Everything a new hire needs to feel welcomed and ready from day one — thoughtfully selected and easy to get started with",
        buttonText: "THE FIRST DAY KIT",
        buttonUrl: "#",
        image: "https://cdn.bystadium.com/plasmic/static-slices/b09-desktop-img.png",
        imageAlt: "First Day Kit",
      },
      {
        id: "2",
        title: "SWAG BASIC",
        description:
          "Essential branded items that make a great impression without breaking the budget.",
        buttonText: "SWAG BASIC",
        buttonUrl: "#",
        image: "https://cdn.bystadium.com/plasmic/static-slices/b09-desktop-img.png",
        imageAlt: "Swag Basic",
      },
      {
        id: "3",
        title: "WORK READY KIT",
        description:
          "Professional essentials to help your team work better and look great doing it.",
        buttonText: "WORK READY KIT",
        buttonUrl: "#",
        image: "https://cdn.bystadium.com/plasmic/static-slices/b09-desktop-img.png",
        imageAlt: "Work Ready Kit",
      },
    ],
    backgroundColor: "#f5f5f5",
  },
  [CE_11]: {
    eyebrowText: "SWAG FOR EVERYONE",
    mainHeading: "Choose your",
    highlightedWord1: "Style",
    highlightedWord2: "Fit",
    highlightedWord3: "Occasion",
    subHeading: "from the biggest swag collection",
    description:
      "Let your swag speak volumes with premium products from the world's greatest catalog.",
    ctaText: "BROWSE SWAG",
    ctaLinkType: CATALOG_HOME_LINK_TYPE,
    ctaOtherUrl: "",
    ctaCategorySlug: "",
    // Grid Item 1
    gridItem1Image: "https://cdn.bystadium.com/plasmic/static-slices/b09-desktop-img.png",
    gridItem1ImageAlt: "On-demand swag",
    gridItem1LinkText: "ON-DEMAND",
    gridItem1LinkUrl: "/collections/on-demand",
    // Grid Item 2
    gridItem2Image: "https://cdn.bystadium.com/plasmic/static-slices/b09-desktop-img.png",
    gridItem2ImageAlt: "Best sellers",
    gridItem2LinkText: "BEST SELLERS",
    gridItem2LinkUrl: "/collections/best-sellers",
    // Grid Item 3
    gridItem3Image: "https://cdn.bystadium.com/plasmic/static-slices/b09-desktop-img.png",
    gridItem3ImageAlt: "Sustainability",
    gridItem3LinkText: "SUSTAINABILITY",
    gridItem3LinkUrl: "/collections/sustainability",
    // Grid Item 4
    gridItem4Image: "https://cdn.bystadium.com/plasmic/static-slices/b09-desktop-img.png",
    gridItem4ImageAlt: "Swag kits",
    gridItem4LinkText: "SWAG KITS",
    gridItem4LinkUrl: "/collections/swag-kits",
    // Grid Item 5
    gridItem5Image: "https://cdn.bystadium.com/plasmic/static-slices/b09-desktop-img.png",
    gridItem5ImageAlt: "Best under $10",
    gridItem5LinkText: "BEST UNDER $10",
    gridItem5LinkUrl: "/collections/best-under-10",
    // Grid Item 6
    gridItem6Image: "https://cdn.bystadium.com/plasmic/static-slices/b09-desktop-img.png",
    gridItem6ImageAlt: "Tradeshow",
    gridItem6LinkText: "TRADESHOW",
    gridItem6LinkUrl: "/collections/tradeshow",
    // Grid Item 7
    gridItem7Image: "https://cdn.bystadium.com/plasmic/static-slices/b09-desktop-img.png",
    gridItem7ImageAlt: "Rush delivery",
    gridItem7LinkText: "RUSH DELIVERY",
    gridItem7LinkUrl: "/collections/rush-delivery",
    // Grid Item 8
    gridItem8Image: "https://cdn.bystadium.com/plasmic/static-slices/b09-desktop-img.png",
    gridItem8ImageAlt: "New arrivals",
    gridItem8LinkText: "NEW ARRIVALS",
    gridItem8LinkUrl: "/collections/new-arrivals",
    // Grid Item 9
    gridItem9Image: "https://cdn.bystadium.com/plasmic/static-slices/b09-desktop-img.png",
    gridItem9ImageAlt: "Clearance sale",
    gridItem9LinkText: "CLEARANCE SALE",
    gridItem9LinkUrl: "/collections/clearance-sale",
  },
  [CE_13]: {
    heading: "Can't Miss Collections",
    catalogs: [
      {
        image: "https://cdn.bystadium.com/plasmic/static-slices/b09-desktop-img.png",
        imageAlt: "Ice shaker",
        catalogTitle: "ICE SHAKER",
        categoryLinkType: CATALOG_HOME_LINK_TYPE,
        linkOtherUrl: "/collections/ice-shaker",
        categorySlug: "",
      },
      {
        image: "https://cdn.bystadium.com/plasmic/static-slices/b09-desktop-img.png",
        imageAlt: "Best college",
        catalogTitle: "BEST COLLEGE",
        categoryLinkType: CATALOG_HOME_LINK_TYPE,
        linkOtherUrl: "",
        categorySlug: "",
      },
      {
        image: "https://cdn.bystadium.com/plasmic/static-slices/b09-desktop-img.png",
        imageAlt: "Tone music studios",
        catalogTitle: "TONE MUSIC STUDIOS",
        categoryLinkType: CATALOG_HOME_LINK_TYPE,
        linkOtherUrl: "",
        categorySlug: "",
      },
      {
        image: "https://cdn.bystadium.com/plasmic/static-slices/b09-desktop-img.png",
        imageAlt: "Cuttwood vapes",
        catalogTitle: "CUTTWOOD VAPES",
        categoryLinkType: CATALOG_HOME_LINK_TYPE,
        linkOtherUrl: "",
        categorySlug: "",
      },
      {
        image: "https://cdn.bystadium.com/plasmic/static-slices/b09-desktop-img.png",
        imageAlt: "Hoodies",
        catalogTitle: "HOODIES",
        categoryLinkType: CATALOG_HOME_LINK_TYPE,
        linkOtherUrl: "",
        categorySlug: "",
      },
      {
        image: "https://cdn.bystadium.com/plasmic/static-slices/b09-desktop-img.png",
        imageAlt: "Novelties and candles",
        catalogTitle: "NOVELTIES & CANDLES",
        categoryLinkType: CATALOG_HOME_LINK_TYPE,
        linkOtherUrl: "",
        categorySlug: "",
      },
      {
        image: "https://cdn.bystadium.com/plasmic/static-slices/b09-desktop-img.png",
        imageAlt: "Cranes soy",
        catalogTitle: "CRANES SOY",
        categoryLinkType: CATALOG_HOME_LINK_TYPE,
        linkOtherUrl: "",
        categorySlug: "",
      },
      {
        image: "https://cdn.bystadium.com/plasmic/static-slices/b09-desktop-img.png",
        imageAlt: "Planners",
        catalogTitle: "PLANNERS",
        categoryLinkType: CATALOG_HOME_LINK_TYPE,
        linkOtherUrl: "",
        categorySlug: "",
      },
    ],
  },
};

export const OTHER_DEFAULTS = {
  [O_03]: {
    cards: [
      {
        image: "https://cdn.bystadium.com/plasmic/static-slices/o03-image.png",
        imageAlt: "Employee recognition",
        cardTitle: "Last-Minute Wins Deserve More Than Last-Minute Scrambles",
        description1:
          "A team member goes above and beyond to deliver a crucial project. Their manager wants to celebrate the effort, but there's no process in place. They either send a Slack shout-out or scramble to order a gift card that doesn't feel personal.",
        description2:
          'The recognition feels rushed or forgotten entirely. The team starts thinking, "Does leadership notice our hard work?"',
        description3:
          "SwagMagic lets you send a branded, thoughtful gift with just a few clicks—no planning or inventory required. Whether a water bottle with their name or a cozy hoodie with your logo, you're creating a tangible \"thank you\" they'll use.",
      },
      {
        image: "https://cdn.bystadium.com/plasmic/static-slices/o03-image-two.png",
        imageAlt: "Employee recognition",
        cardTitle: "Company-Wide Milestones That Feel Company-Wide",
        description1:
          "It's your company's 5th anniversary. You want to celebrate the team across multiple locations. But coordinating gifts across regions, time zones, and hybrid schedules feels like a logistical nightmare.",
        description2:
          'Only HQ gets celebrated. Remote or hybrid employees feel left out, reinforcing the "us vs. them" dynamic. Instead of bringing the team together, the milestone becomes a miss.',
        description3:
          "Order bulk swag with centralized tracking, kitted packaging, and global shipping. Everyone gets the same great experience, on time, and brand. No one feels like an afterthought.",
      },
      {
        image: "https://cdn.bystadium.com/plasmic/static-slices/o03-image.png",
        imageAlt: "Employee recognition",
        cardTitle: "Birthdays & Workiversaries—Don't Let Them Slip Through the Cracks",
        description1:
          "You've got birthdays, anniversaries, and promotions to celebrate every month. But managing this manually is exhausting. You forget one, and suddenly it's awkward. Or worse, only some people get recognized.",
        description2:
          'Inconsistency kills credibility. If recognition only happens for the "loudest" teams or those with proactive managers, others feel undervalued, even resentful.',
        description3:
          "Automate it. Sync your HRIS or upload your team list—swagMagic triggers the right gift at the right time, without anyone needing to remember. Recognition becomes consistent, fair, and morale-boosting.",
      },
      {
        image: "https://cdn.bystadium.com/plasmic/static-slices/o03-image-two.png",
        imageAlt: "Employee recognition",
        cardTitle: "Say Goodbye to One-Size-Fits-None Swag",
        description1:
          "You order branded hoodies for your team. But half don't like the style, some get the wrong size, and the extras sit in storage. The result? Budget wasted, excitement lost.",
        description2:
          "Your good intentions can turn into a forgettable (or frustrating) experience. Generic swag can feel more like clutter than appreciation.",
        description3:
          "Launch a company swag store. Let employees choose what they want—from apparel to wellness kits. You stay on brand, they stay excited—and nothing goes to waste.",
      },
    ],
  },
  [A_01]: {
    heading: "Frequently Asked Questions",
    faq: [
      {
        question: "Do I need an account to place an order on SwagMagic?",
        answer:
          "You can browse without an account, but creating one allows you to save addresses, view past orders, and manage bulk campaigns efficiently.",
      },
      {
        question: "Can individuals use SwagMagic or is it only for businesses?",
        answer:
          "SwagMagic is designed for both individuals and businesses. Whether you need swag for personal events or corporate gifting, we have solutions for everyone.",
      },
      {
        question: "Where are SwagMagic products shipped from?",
        answer:
          "Our products are shipped from various warehouses across the United States to ensure fast delivery times and reduced shipping costs.",
      },
      {
        question: "Can I ship to multiple addresses in one order?",
        answer:
          "Yes, you can ship to multiple addresses in a single order. This is perfect for corporate gifting or sending swag to remote team members.",
      },
    ],
  },
};
// Utility functions
export const createHideProps = (variant: string) => (props: { variant?: string }) =>
  props.variant !== variant;

// Pre-created hide functions for each variant
export const hideB01Props = createHideProps(B_01);
export const hideB02Props = createHideProps(B_02);
export const hideB02bProps = createHideProps(B_02b);
export const hideB03Props = createHideProps(B_03);
export const hideB04Props = createHideProps(B_04);
export const hideB05Props = createHideProps(B_05);
export const hideB06Props = createHideProps(B_06);
export const hideB07Props = createHideProps(B_07);
export const hideB08Props = createHideProps(B_08);
export const hideB09Props = createHideProps(B_09);
export const hideB10Props = createHideProps(B_10);
export const hideB12Props = createHideProps(B_12);
export const hideB13Props = createHideProps(B_13);
export const hideB14Props = createHideProps(B_14);
export const hideB15Props = createHideProps(B_15);
export const hideB16Props = createHideProps(B_16);
export const hideB17Props = createHideProps(B_17);
export const hideB18Props = createHideProps(B_18);
export const hideB19Props = createHideProps(B_19);
export const hideB20Props = createHideProps(B_20);
export const hideB21Props = createHideProps(B_21);
export const hideB22Props = createHideProps(B_22);
export const hideB23Props = createHideProps(B_23);

export const hideH01Props = createHideProps(H_01);
export const hideH02Props = createHideProps(H_02);
export const hideH03Props = createHideProps(H_03);
export const hideH04Props = createHideProps(H_04);
export const hideH05Props = createHideProps(H_05);
export const hideH06Props = createHideProps(H_06);
export const hideH07Props = createHideProps(H_07);
export const hideH08Props = createHideProps(H_08);

export const hideLS03Props = createHideProps(L_03);

export const hideBG01Props = createHideProps(BG_01);
export const hideBG02Props = createHideProps(BG_02);
export const hideBG03Props = createHideProps(BG_03);

export const hideCE10Props = createHideProps(CE_10);
export const hideCE11Props = createHideProps(CE_11);
export const hideCE13Props = createHideProps(CE_13);

export const hideBE06Props = createHideProps(BE_06);

export const hideT02Props = createHideProps(T_02);

export const A01_DEFAULTS = {
  heading: "Frequently Asked Questions",
  faq: OTHER_DEFAULTS[A_01].faq,
  className: "",
};

export type ControlContextSlugs = { value: string; label: string }[];

export const getCategoriesMap = (categories: any[]): ControlContextSlugs => {
  if (!categories?.length) return [];

  return categories.map((category) => ({
    value: category.code,
    label: category.name,
  }));
};
